(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _getTemplate = require('./getTemplate');

var _getTemplate2 = _interopRequireDefault(_getTemplate);

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var pondyPopPlugin = function () {
    function pondyPopPlugin() {
        _classCallCheck(this, pondyPopPlugin);

        this.data = pondyPopData;
        this.popup;
        this.hasUserSeenPopup = false;
        this.isPopupVisible = false;
    }

    _createClass(pondyPopPlugin, [{
        key: 'init',
        value: function init() {

            this.loadFonts();
            var display = this.data.display;

            switch (display) {

                case 'homepage':
                    if (window.location.href === this.data.siteURL && (!this.data.enableCookies || !_jsCookie2.default.get('pondypop-plugin')) && this.data.activate) {
                        this.renderPopup(true);
                        this.setListeners();
                    } else if (this.data.activate) {
                        this.renderPopup(false);
                        this.setListeners();
                    }

                    break;

                default:
                    if (!this.hasUserSeenPopup && (!this.data.enableCookies || !_jsCookie2.default.get('pondypop-plugin')) && this.data.activate) {
                        this.renderPopup(true);
                        this.setListeners();
                    } else if (this.data.activate) {
                        this.renderPopup(false);
                        this.setListeners();
                    }
                    break;
            }
        }
    }, {
        key: 'loadFonts',
        value: function loadFonts() {

            var fonts = [{
                font: this.data.headingFont,
                weight: this.data.headingFontWeight
            }, {
                font: this.data.subheadingFont,
                weight: this.data.subheadingFontWeight
            }];

            fonts.forEach(function (font) {
                if (font.font !== null && font.font !== "" && font.weight !== null && font.weight !== "") {
                    WebFont.load({
                        google: {
                            families: [font.font + ':' + font.weight]
                        }
                    });
                }
            });
        }
    }, {
        key: 'cycleHeadings',
        value: function cycleHeadings() {
            var headings = this.data.headline;
            var index = 0;

            var intervalID = setInterval(function () {
                ++index;
                if (index >= headings.length) {
                    index = 0;
                }
                document.getElementById("popup-heading").innerHTML = headings[index];
            }, 5000);
        }
    }, {
        key: 'cycleSubheadings',
        value: function cycleSubheadings() {
            var subHeadings = this.data.subHeading;
            var index = 0;

            var intervalID = setInterval(function () {
                ++index;
                if (index >= subHeadings.length) {
                    index = 0;
                }
                document.getElementById("popup-subheading").innerHTML = subHeadings[index];
            }, 5000);
        }
    }, {
        key: 'renderPopup',
        value: function renderPopup() {
            var _this = this;

            var showfullscreen = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            var delay = this.data.delay !== null && this.data.delay !== "" ? this.data.delay : 0;
            var popup = document.createElement('div');
            popup.innerHTML = (0, _getTemplate2.default)(this.data);
            popup.id = 'pondypop-popup';
            document.body.appendChild(popup);
            this.popup = popup;
            this.isPopupVisible = true;

            setTimeout(function () {
                if (showfullscreen) {
                    popup.classList.add('pondypop-visible');
                }
                _this.cycleHeadings();
                _this.cycleSubheadings();
            }, delay * 1000);
        }
    }, {
        key: 'setListeners',
        value: function setListeners() {
            var _this2 = this;

            if (this.data.hasToggle) {
                // alert('dont close me bro');
                this.popup.querySelector('.popup-close').addEventListener('click', function () {
                    _this2.popup.classList.remove('pondypop-visible');
                    _this2.isPopupVisible = !_this2.isPopupVisible;
                    if (_this2.data.enableCookies && !_jsCookie2.default.get('pondypop-plugin')) {
                        var cookieExpiry = _this2.data.cookieExpire !== null && _this2.data.cookieExpire !== "" ? parseInt(_this2.data.cookieExpire) : 30;
                        _jsCookie2.default.set('pondypop-plugin', 1, {
                            expires: cookieExpiry
                        });
                    }
                });

                this.popup.querySelector('.popup-toggle').addEventListener('click', function () {
                    _this2.popup.classList.add('pondypop-visible');
                    _this2.isPopupVisible = !_this2.isPopupVisible;
                });
            } else {
                this.popup.querySelector('.popup-close').addEventListener('click', function () {
                    _this2.popup.classList.remove('pondypop-visible');
                    _this2.isPopupVisible = !_this2.isPopupVisible;
                    if (_this2.data.enableCookies && !_jsCookie2.default.get('pondypop-plugin')) {
                        var cookieExpiry = _this2.data.cookieExpire !== null && _this2.data.cookieExpire !== "" ? parseInt(_this2.data.cookieExpire) : 30;
                        _jsCookie2.default.set('pondypop-plugin', 1, {
                            expires: cookieExpiry
                        });
                    }
                });
            }
        }
    }]);

    return pondyPopPlugin;
}();

exports.default = pondyPopPlugin;

},{"./getTemplate":2,"js-cookie":4}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var getTemplate = function getTemplate(data) {

    var backgroundColour = data.backgroundColour !== null && data.backgroundColour !== "" ? data.backgroundColour : '#080B10';
    var primaryColour = data.primaryColour !== null && data.primaryColour !== "" ? data.primaryColour : '#FDCF04';
    var secondaryColour = data.secondaryColour !== null && data.secondaryColour !== "" ? data.secondaryColour : '#FFF';
    var justify = data.justify !== null && data.justify !== "" ? data.justify : 'left';
    var subheadings = '';
    var link = '';
    var secondaryLink = '';
    var toggle = '';

    if (data.linkLabel !== null && data.linkLabel !== "") {

        var link_style = '';

        if (data.subheadingFontWeight !== '') {
            link_style = "font-weight: " + data.subheadingFontWeight + ";";
        }

        link = "\n            <a class=\"pondypop-cta\" href=\"" + data.linkURL + "\" target=\"_blank\" style= \"color: " + secondaryColour + "; " + link_style + "\">\n                " + data.linkLabel + "\n            </a>\n        ";
    }

    if (data.secondaryLinkLabel !== null && data.secondaryLinkLabel !== "") {

        var link_style = '';

        if (data.subheadingFontWeight !== '') {
            link_style = "font-weight: " + data.subheadingFontWeight + ";";
        }

        secondaryLink = "\n            <a class=\"pondypop-cta\" href=\"" + data.secondaryLinkURL + "\" target=\"_blank\" style= \"color: " + secondaryColour + "; " + link_style + "\">\n                " + data.secondaryLinkLabel + "\n            </a>\n        ";
    }

    if (data.hasToggle !== null && data.hasToggle && data.toggleLabel !== null && data.toggleLabel !== "") {

        var toggle_style = '';

        if (data.asset !== '') {
            toggle_style = "background-image: url(" + data.asset + ");";
        }

        if (data.headingFont !== '') {
            toggle_style += "font-family: " + data.headingFont + "; font-weight: " + data.headingFontWeight + ";";
        }

        if (data.headingFontWeight !== '') {
            toggle_style += "font-weight: " + data.headingFontWeight + ";";
        }

        toggle = "\n            <a class=\"popup-toggle popup-toggle--" + data.togglePlacement + "\" style=\"color: " + secondaryColour + "; " + toggle_style + "\">\n                " + data.toggleLabel + "\n                <div class=\"toggle-inner\">\n                    <span style=\"background-color: " + primaryColour + ";\"></span>\n                    <span style=\"background-color: " + primaryColour + ";\"></span>\n                </div>\n            </a>\n        ";
    }

    var pi_style = '',
        ph_style = '',
        psh_style = '';

    if (data.asset !== '') {
        pi_style = "background-image: url(" + data.asset + ");";
    }

    if (data.headingFont !== '') {
        ph_style = "font-family: " + data.headingFont + ";";
    }

    if (data.headingFontWeight !== '') {
        ph_style += "font-weight: " + data.headingFontWeight + ";";
    }

    if (data.subheadingFontWeight !== '') {
        psh_style += "font-weight: " + data.subheadingFontWeight + ";";
    }

    var template = "\n        <div class=\"popup-inner\" style=\"background-color: " + backgroundColour + "; " + pi_style + "\">\n            <div class=\"popup-headline\" style=\"text-align: " + justify + "; font-family: " + data.subheadingFont + ";\">\n                <h2 id=\"popup-heading\" style=\"color: " + primaryColour + "; " + ph_style + "\">" + data.headline[0] + "</h2>\n                <div class=\"popup-subheadings\">\n                    <h3 id=\"popup-subheading\" style=\"color: " + secondaryColour + "; " + psh_style + ";\">" + data.subHeading[0] + "</h3>\n                </div>\n                <div class=\"popup-links\">\n                    " + link + "\n                    " + secondaryLink + "\n                </div>\n            </div>\n            <div class=\"popup-close\" style=\"border: 2px solid " + secondaryColour + ";\">\n                <div class=\"close-inner\">\n                    <span style=\"background-color: " + primaryColour + ";\"></span>\n                    <span style=\"background-color: " + primaryColour + ";\"></span>\n                </div>\n            </div>\n        </div>\n        " + toggle + "\n\n        <style type=\"text/css\">\n            #pondypop-popup .popup-close:hover {\n                background-color: " + secondaryColour + " !important;\n            }\n        </style>\n    ";

    return template;
};

exports.default = getTemplate;

},{}],3:[function(require,module,exports){
'use strict';

var _App = require('./App');

var _App2 = _interopRequireDefault(_App);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

jQuery(document).ready(function ($) {
    var popup = new _App2.default();
    popup.init();
});

},{"./App":1}],4:[function(require,module,exports){
/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader;
	if (typeof define === 'function' && define.amd) {
		define(factory);
		registeredInModuleLoader = true;
	}
	if (typeof exports === 'object') {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function decode (s) {
		return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
	}

	function init (converter) {
		function api() {}

		function set (key, value, attributes) {
			if (typeof document === 'undefined') {
				return;
			}

			attributes = extend({
				path: '/'
			}, api.defaults, attributes);

			if (typeof attributes.expires === 'number') {
				attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
			}

			// We're using "expires" because "max-age" is not supported by IE
			attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

			try {
				var result = JSON.stringify(value);
				if (/^[\{\[]/.test(result)) {
					value = result;
				}
			} catch (e) {}

			value = converter.write ?
				converter.write(value, key) :
				encodeURIComponent(String(value))
					.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

			key = encodeURIComponent(String(key))
				.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
				.replace(/[\(\)]/g, escape);

			var stringifiedAttributes = '';
			for (var attributeName in attributes) {
				if (!attributes[attributeName]) {
					continue;
				}
				stringifiedAttributes += '; ' + attributeName;
				if (attributes[attributeName] === true) {
					continue;
				}

				// Considers RFC 6265 section 5.2:
				// ...
				// 3.  If the remaining unparsed-attributes contains a %x3B (";")
				//     character:
				// Consume the characters of the unparsed-attributes up to,
				// not including, the first %x3B (";") character.
				// ...
				stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
			}

			return (document.cookie = key + '=' + value + stringifiedAttributes);
		}

		function get (key, json) {
			if (typeof document === 'undefined') {
				return;
			}

			var jar = {};
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all.
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = decode(parts[0]);
					cookie = (converter.read || converter)(cookie, name) ||
						decode(cookie);

					if (json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					jar[name] = cookie;

					if (key === name) {
						break;
					}
				} catch (e) {}
			}

			return key ? jar[key] : jar;
		}

		api.set = set;
		api.get = function (key) {
			return get(key, false /* read as raw */);
		};
		api.getJSON = function (key) {
			return get(key, true /* read as json */);
		};
		api.remove = function (key, attributes) {
			set(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.defaults = {};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));

},{}]},{},[3]);
